import { toast } from "react-toastify"
// import useJwt from '@src/auth/jwt/useJwt'
import "./helper.css"
import { string } from "prop-types"


const helper = {
    toastNotification(message, type) {
        toast(message, {
            type: type === 'SUCCESS_MESSAGE' ? "success" : "error",
            autoClose: 4000,
            className:
                type === 'SUCCESS_MESSAGE' ? 'toastContainerSuccess' : 'toastContainer'
        })
    },
    // Date Related Methods
    getCurrentDate() {
        const currentdate = new Date()
        return `${currentdate.getFullYear()}-${currentdate.getMonth() + 1}-${currentdate.getDate()}`
    },
    getDateFrom(days) {
        const currentdate = new Date()
        return new Date(currentdate.setDate(currentdate.getDate() - days))
    },
    // Error
    formatDateInHashes(date) {
        if (date !== '') {
            const currentdate = new Date(date.setDate(date.getDate()))
            return `${currentdate.getFullYear()}-${currentdate.getMonth() + 1}-${currentdate.getDate()}`
        } else {
            return ''
        }
    },
    formatDateInSlash(date) {
        if (date === null || date === '' || date === undefined) {
            return ''
        }

        date = new Date(date)
        const currentdate = new Date(date.setDate(date.getDate()))

        const formattedDate = `${currentdate.getMonth() + 1}/${currentdate.getDate()}/${currentdate.getFullYear()}`
        return formattedDate
    },
    formatDate(timestamp, dateformat = 'dd-m-yy') {
        if (timestamp) {
            const a = new Date(timestamp)
            a.format(dateformat)
            return a
        } else {
            const a = new Date()
            a = a.format(dateformat)
            return a
        }
    },
    removeTimeFromDate(date) {
        if (date === '' || date === null || date === undefined) {
            return ''
        }

        const currentdate = new Date(date)
        let month = currentdate.getMonth() + 1
        let day = currentdate.getDate()
        if (month < 10) {
            month = `0${month}`
        }

        if (day < 10) {
            day = `0${day}`
        }
        return `${currentdate.getFullYear()}-${month}-${day}`
    },
    getObjTime(e) {
        if (e !== null) {
            const split = String(e).split(' ')
            if (split[1].length === 8) {
                return (split[1])
            } else {
                let hrs = e.getHours()
                let min = e.getMinutes()
                let sec = e.getSeconds()
                if (hrs < 10) hrs = '0' + hrs
                if (min < 10) min = '0' + min
                if (sec < 10) sec = '0' + sec
                return `${hrs}:${min}:${sec}`
            }
        } else {
            return (null)
        }
    },

    dateFormater(date) {
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        var day = date.getDate();
        // get month from 0 to 11
        var month = date.getMonth();
        // conver month digit to month name
        month = months[month];
        var year = date.getFullYear();

        // show date in two digits
        if (day < 10) {
            day = '0' + day;
        }

        // now we have day, month and year
        // arrange them in the format we want
        return month + ' ' + day + ', ' + year;
    },

    // String Related Methods
    stringToJson(string) {
        try {
            return JSON.parse(string)
        } catch (e) {
            return string
        }
    },
    jsonToString(string) {
        try {
            return JSON.stringify(string)
        } catch (e) {
            return string
        }
    },
    showArabicText(json) {
        return json.ar ? json.ar : ''
    },
    showEnglishText(json) {
        return json.en ? json.en : ''
    },
    shortTextWithDots(text, character) {
        const string = text.substring(0, character)
        return (text.length > character) ? `${string} ...` : string
    },

    // Auth Related Methods
    // redirectToLogin(code) {
    //     if (code === 401) {
    //         const config = useJwt.jwtConfig
    //         localStorage.removeItem('userDataAdmin')
    //         localStorage.removeItem(config.adminTokenKeyName)
    //         localStorage.removeItem(config.storageRefreshTokenKeyName)
    //         window.location = `${window.location.origin}/admin/login`
    //         return false
    //     }
    //     return true
    // },
    // redirectToCustomerLogin(code, response = null) {
    //     if (code === 401) {
    //         if (response) {
    //             this.toastNotification(response.message, "FAILED_MESSAGE");
    //         }
    //         const config = useJwt.jwtConfig
    //         localStorage.removeItem('userDataCustomer')
    //         localStorage.removeItem(config.customerTokenKeyName)
    //         localStorage.removeItem(config.storageRefreshTokenKeyName)

    //         window.location = `${window.location.origin}/login`
    //         return false
    //     }
    //     return true
    // },

    // Clean
    cleanString(value) {
        return (value.replace(/[|&;$%@"./<>()+,]/g, ""))
    },
    cleanDecimal(value) {
        const pos = value.indexOf(".")
        let result
        if (pos !== -1) {
            const part1 = value.substr(0, pos)
            const part2 = value.substr(pos + 1)

            result = `${this.cleanDeciamalRegex(part1)}.${this.cleanDeciamalRegex(part2)}`
        } else {
            result = this.cleanDeciamalRegex(value)
        }
        return result
    },
    cleanDeciamalRegex(string) {
        return string.replace(/[^0-9]/g, "")
    },
    cleanInteger(string) {
        return string.replace(/\D/g, '')
    },
    cleanMobile(string) {
        return string.replace(/[a-zA-Z~`!@#$%\^&*_={}\[\]|\\:;"'<>,.\/]/g, '')
    },
    // Table Related
    applyCountID(data, current_page, itemsCountPerPage) {
        if (data !== '' && data !== undefined && data !== null) {
            for (let i = 0; i < data.length; i++) {

                if (current_page && itemsCountPerPage) {
                    data[i].count_id = (current_page - 1) * itemsCountPerPage + (i + 1);
                } else {
                    data[i].count_id = i + 1;
                }
            }
        }
        return data
    },
    applyRowClass(arg) {
        return (arg && arg.count_id % 2 == 0) ? true : false
    },
    // Url Related
    getIDfromUrl(url) {
        try {
            const id = url.substring(url.lastIndexOf('/') + 1)
            return parseInt(id)
        } catch (e) {
            return false
        }
    },
    getStoreID() {
        // if (localStorage.getItem("authtoken")) {
        //     const jwtString = jwt.decode(localStorage.getItem("authtoken"))
        //     return jwtString.store_id
        // }
        // return '',
        return 1000
    },
    isPathOms(pathname) {
        if (pathname && pathname.length) {
            if (pathname.indexOf('oms') > -1) {
                return true
            }
        }

        return false
    },
    // Type Related
    isEmail(value) {
        if (!value) {
            return false
        } else {
            if (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
                return false
            } else {
                return true
            }
        }
    },
    isValidMobile(string) {
        if (!string) {
            return false;
        }

        if (string.length != 12) { // mb length should be 12 with country code (966)
            return false;
        }

        return true;

        // let regex = /([(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i; //regular expression for valid mobile phone number (580)
        // return regex.test(string) 
    },
    isObject(value) {
        if (value === null || value === undefined || value === "") {
            return false
        } else if (Object.keys(value).length !== 0) {
            return true
        } else {
            return false
        }
    },
    isArray(data) {
        try {
            if (data?.length) {
                return true
            } else {
                return false
            }
        } catch (e) {
            return false
        }
    },
    isEmptyString(str) {
        if (str === '' || str === undefined || str === null) {
            return true
        }
        return false
    },
    isEmptyArrayReplaceWithNull(str) {
        if (str.length === 0) {
            return null
        }
        return str
    },
    isEmptyReplaceWithArray(str) {
        if (str.length === 0) {
            return []
        }
        return str
    },
    isNullReplaceWithArray(data) {
        if (data === null) {
            return []
        }
        return data
    },
    isTrueReplaceWith1(str) {
        if (str === true) {
            return 1
        } else {
            return 0
        }
    },
    isEmptyReplaceWithNull(val) {
        if (val === '' || val === undefined || val === null) {
            return null
        }
        return val
    },
    checkinteger(integer) {
        if (isNaN(integer)) {
            return integer
        } else {
            return parseInt(integer)
        }
    },
    // Time Related Method
    extractTime(timestamp) {
        const dateObj = new Date(timestamp);
        const hours = dateObj.getUTCHours();
        const minutes = dateObj.getUTCMinutes();
        const seconds = dateObj.getUTCSeconds();
        return `${hours}:${minutes}:${seconds}`;
    },
    addSecondsInDate(newDate, sec) {
        const date = new Date(newDate)
        return date.setSeconds(date.getSeconds() + sec)
    },
    formatAMPM(date) {
        let hours = date && date?.getHours()
        let minutes = date?.getMinutes()
        const ampm = hours >= 12 ? 'pm' : 'am'
        hours = hours % 12
        hours = hours ? hours : 12 // the hour '0' should be '12'
        minutes = minutes < 10 ? `0${minutes}` : minutes
        const strTime = `${hours}:${minutes} ${ampm}`
        return strTime
    },
    formatDateWithTime(dateString) {
        const date = new Date(dateString); // Parse the date string
        const day = date.getDate(); // Get the day of the month
        const month = date.getMonth() + 1; // Get the month (months are zero-indexed)
        const year = date.getFullYear(); // Get the year
        let hours = date.getHours(); // Get the hours
        let minutes = date.getMinutes(); // Get the minutes
    
        // Format hours in 12-hour format with "am" or "pm"
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12 || 12; // Convert hours to 12-hour format
        minutes = minutes < 10 ? '0' + minutes : minutes; // Add leading zero if minutes is less than 10
    
        // Construct the formatted date string
        const formattedDate = `${day < 10 ? '0' + day : day}-${month < 10 ? '0' + month : month}-${year} ${hours}:${minutes}${ampm}`;
        return formattedDate;
    },
    convertStrTimeToAMPM(time) {
        var hours = Number(time?.substr(0, 2));
        var minutes = Number(time?.substr(3, 2));
        var seconds = Number(time?.substr(6, 2));
        var ampm = (hours >= 12) ? "PM" : "AM";
        hours = (hours % 12);
        hours = (hours ? hours : 12); // the hour '0' should be '12'
        minutes = (minutes < 10 ? "0" : "") + minutes;
        seconds = (seconds < 10 ? "0" : "") + seconds;
        var strTime = hours + ":" + minutes + ":" + seconds + " " + ampm;
        return strTime;
    },
    calculateDuration(time1, time2) {
        // convert the timestamps to Date objects
        let date1 = new Date(time1);
        let date2 = new Date(time2);

        // calculate the difference in milliseconds
        let difference = Math.abs(date2 - date1);

        // calculate the difference in hours and minutes
        let minutes = Math.floor((difference / 1000) / 60);
        let hours = Math.floor(minutes / 60);
        minutes = minutes % 60;

        return `${hours} Hrs ${minutes} mins`;

    },
    timeDifference(time1, time2) {
        const date1 = new Date(time1)
        const date2 = new Date(time2)
        const diff = date2.getTime() - date1.getTime()
        let msec = diff
        const hh = Math.floor(msec / 1000 / 60 / 60)
        msec -= hh * 1000 * 60 * 60
        const mm = Math.floor(msec / 1000 / 60)
        msec -= mm * 1000 * 60
        const ss = Math.floor(msec / 1000)
        msec -= ss * 1000
        return `${hh}:${mm}:${ss}`
    },
    timeAdd(time1, time2) {

        if (!time1) {
            return "";
        }

        let split_time1 = [];

        if (typeof time1 == string) {
            split_time1 = time1.split(":");
        } else {
            split_time1 = time1.toString().split(":");
        }

        let hh1 = 0;
        let mm1 = 0;
        let ss1 = 0;

        if (split_time1.length == 1) {
            mm1 = parseInt(split_time1[0]);
        }

        if (split_time1.length > 1) {
            hh1 = parseInt(split_time1[0]);
            mm1 = parseInt(split_time1[1]);
        }

        if (split_time1.length > 2) {
            ss1 = parseInt(split_time1[2]);
        }

        if (!time2) {

            if (ss1 > 59) {
                let sec1 = ss1 / 60;
                ss1 = ss1 % 60;
                mm1 += sec1;
            }

            if (mm1 > 59) {
                let hr1 = mm1 / 60;
                mm1 = mm1 % 60;
                hh1 += hr1;
            }
            return `${hh1}:${mm1}:${ss1}`
        }

        let split_time2 = [];
        if (typeof time2 == string) {
            split_time2 = time2.split(":");
        } else {
            split_time2 = time2.toString().split(":");
        }

        let hh2 = 0;
        let mm2 = 0;
        let ss2 = 0;

        if (split_time2.length == 1) {
            mm2 = parseInt(split_time2[0]);
        }

        if (split_time2.length > 1) {
            hh2 = parseInt(split_time2[0]);
            mm2 = parseInt(split_time2[1]);
        }

        if (split_time2.length > 2) {
            ss2 = parseInt(split_time2[2]);
        }

        let ss = ss1 + ss2;
        let mm = mm1 + mm2;
        let hh = hh1 + hh2;

        if (ss > 59) {
            let sec = ss / 60;
            ss = ss % 60;
            mm += sec;
        }

        if (mm > 59) {
            let hr = mm / 60;
            mm = mm % 60;
            hh += hr;
        }

        return `${hh}:${mm}:${ss}`;
    },
    toTimestamp(strDate) {
        const datum = Date.parse(strDate)
        return datum / 1000
    },
    timeInHrsMins(mins) {
        var hours = (mins / 60);
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) * 60;
        var rminutes = Math.round(minutes);
        if (rhours == 0) {
            return rminutes + "Min";
        }
        else if (rminutes == 0) {
            return rhours + "Hr ";
        }
        else {
            return rhours + "Hr " + rminutes + "Min";
        }
    },
    findTimeDiference(strDate) {
        let datum
        if (strDate === '' || strDate === undefined || strDate === null) {
            datum = new Date().getTime()
        } else {
            datum = Date.parse(strDate)
        }

        const seconds = new Date().getTime() / 1000
        const timestamp = datum / 1000

        let ago = parseInt(seconds - timestamp)
        if (ago > 59) {
            ago = parseInt(ago / 60)

            if (ago > 59) {
                ago = parseInt(ago / 60)

                if (ago > 23) {
                    ago = parseInt(ago / 24)

                    if (ago > 1) {
                        ago += ' days ago'
                    } else {
                        ago += ' day ago'
                    }

                } else {
                    if (ago > 1) {
                        ago += ' hours ago'
                    } else {
                        ago += ' hour ago'
                    }
                }

            } else {
                if (ago > 1) {
                    ago += ' minutes ago'
                } else {
                    ago += ' minute ago'
                }
            }

        } else {
            if (ago > 1) {
                ago += ' seconds ago'
            } else {
                ago += ' second ago'
            }
        }

        return ago
    },

    // Calculation Related
    calculateDistance(lat1, lon1, lat2, lon2) {
        const R = 6371
        const dLat = this.toRad(lat2 - lat1)
        const dLon = this.toRad(lon2 - lon1)
        const Lat1 = this.toRad(lat1)
        const Lat2 = this.toRad(lat2)

        const a = ((Math.sin(dLat / 2) * Math.sin(dLat / 2)) +
            (Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(Lat1) * Math.cos(Lat2)))
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
        const d = R * c
        return d
    },
    toRad(Value) {
        return Value * Math.PI / 180
    },

    checkRole(role, user_roles) {

        if (user_roles) {
            if (user_roles !== null && user_roles !== undefined && user_roles.length === 0) {
                return true
            }

            if (user_roles !== null && user_roles !== undefined && user_roles.indexOf(role) > -1) {
                return true
            }
        }

        return false
    },
    checkGroup(group, user_group) {

        if (user_group) {
            if (user_group !== null && user_group !== undefined && user_group === group) {
                return true
            }
        }


        return false
    },

    isCancelableOrder(order_status) { // placed = 5,waiting for approval = 15,
        // Modified By @imtinan @05-01-2023 
        if (order_status !== 'EXECUTION') {
            return true
        }
        return false
    },
    isPlanningOrder(order_status) { // waiting for approval = 15, approved = 17
        if (order_status === 'WAITING_FOR_ACCEPTANCE' || order_status === 'ACCEPTED' || order_status === 'EXECUTION') {
            return true
        }
        return false
    },
    isPlacedOrder(order_status) {
        if (order_status === 'PLACED') {
            return true
        }
        return false
    },
    isAssetAssignment(order_status) {
        if (order_status === 'ACCEPTED') {
            return true;
        }
        return false;
    },
    isOmsPickupOrder(order) {
        if (order && order.category && order.category.key == 'PICKUP' && window.location.href.indexOf('/admin/') == -1) {
            return true;
        }

        return false;
    }
}

export default helper